import { render } from "./index.vue?vue&type=template&id=8ae17e78&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8ae17e78&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=8ae17e78&lang=css"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae17e78"]])

export default __exports__